import { Helmet } from 'react-helmet';
import Layout from '../../Layout';
import { useWindowResizeEffect } from '../../hooks/resizeHeight';
import Disclaimer from '../../components/disclaimer';
import useDesktopCheck from '../../hooks/useDesktopCheck';

const Thankyou = () => {
  const height = useWindowResizeEffect();
  const isDesktop = useDesktopCheck();
  const title = 'Caraiman';
  const description =
    'Vezi cum e viața la cabană și aplică învățăturile Cabanierului: când dai de greu pe traseu, stai puțin, trage-ți sufletul și încearcă un Caraiman rece.';
  return (
    <Layout>
      <Helmet>
        <title>Sa fie cu noroc | {title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={description} />
      </Helmet>
      <div
        style={{ minHeight: height + 20 }}
        className="bg-secondary-grey flex flex-col justify-center items-center text-primary-green text-center px-6 pb-24"
      >
        <img
          className="w-52 lg:w-96 mt-24"
          src="/images/ei_export.png"
          alt="Doi oameni"
        />
        <h1 className="text-4xl lg:text-7xl font-extrabold tracking-wider mt-3">
          MULT SUCCES!
        </h1>
        <h2 className="font-sans text-lg lg:text-4xl font-normal tracking-wider">
          Mulțumim pentru înscrierea în promoție. De acum, tot ce rămâne de{' '}
          <br className="block" /> făcut e să stai, să-ți tragi sufletul și să
          te gândești ce ai face cu banii.
          <br />
          <br />
          Iar când vine din nou timpul să te bucuri de o bere răcoritoare,
          <br />
          deschide încă un Caraiman și înscrie încă un cod.
        </h2>
        <h3 className="font-sans text-2xl lg:text-4xl font-bold tracking-wide leading-tight mt-10">
          Să fie cu noroc!
        </h3>
      </div>
      <Disclaimer
        textColor="text-primary-green"
        image="/images/icons-green.png"
      />
      <Disclaimer
        textColor={
          isDesktop ? 'text-primary-green' : 'text-secondary-grey-light'
        }
        shadow={isDesktop ? '' : 'tail-shadow'}
        image={isDesktop ? '/images/icons-green.png' : '/images/icons2.png'}
      />
    </Layout>
  );
};

export default Thankyou;
